import type { ReactNode } from "react"
import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet"
import {
  ScheduleListPanel,
  type ScheduleListPanelProps,
} from "@/components/word-form/ScheduleListPanel"

export interface ScheduleListSheetProps extends ScheduleListPanelProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** The Word file's name. */
  filename: string
  /** The sheet's one main action, e.g. "Open form". */
  action?: ReactNode
  /** A short line under the title, e.g. why corrections are unavailable. */
  note?: string
  /** The count to show while the list itself is still loading. */
  scheduleCount?: number
}

/** The schedule list in a right-hand sheet, for the tender file and the form page. */
export function ScheduleListSheet({
  open,
  onOpenChange,
  filename,
  action,
  note,
  scheduleCount,
  ...panelProps
}: ScheduleListSheetProps) {
  const count = scheduleCount ?? panelProps.schedules.length
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="flex w-full flex-col gap-0 p-0 sm:max-w-lg">
        <div className="space-y-1 border-b border-border px-4 py-3 pr-12">
          <SheetTitle className="truncate text-sm font-medium">{filename}</SheetTitle>
          <SheetDescription className="text-meta">
            {count} {count === 1 ? "schedule" : "schedules"} found
          </SheetDescription>
          {note && <p className="text-meta">{note}</p>}
          {action && <div className="pt-1">{action}</div>}
        </div>
        <div className="min-h-0 flex-1 overflow-auto px-4 py-2">
          <ScheduleListPanel {...panelProps} />
        </div>
      </SheetContent>
    </Sheet>
  )
}
